export function initializePage(brand: string | null) {
  if (!brand) return;

  const capitalizedBrand = brand.charAt(0).toUpperCase() + brand.slice(1);

  document.title = `BikeHero | ${capitalizedBrand}`;

  const description = document.querySelector('meta[name="description"]');
  if (description) {
    description.setAttribute(
      "content",
      `Seguro ${capitalizedBrand}: Segurança sem franquia, liberdade sem custo`
    );
  }
}
